module.exports = __webpack_public_path__ + "static/media/full_time.b2c0683d.png";